import React from 'react';
import { PRIVATE_MARKDOWN_LIST_GROUP } from './subcomponents';
import { IStyle, mergeStyles } from '@fluentui/react';
import { useCollectionKeys } from '../../../../framework/hooks/collection-keys';
import { IListComponentModel } from '../../parser/list';

const getStyleClass = () => {
  const style: IStyle = {
    padding: 0,
    margin: 0,
    fontSize: '1em',
    marginBottom: '1em',
  };

  return mergeStyles([ style ]);
}
export const MarkdownList: React.FunctionComponent<IListComponentModel> = (props) => {
  const { groups } = props;
  const styleClass = getStyleClass();
  const groupKeys = useCollectionKeys(groups);

  return (
    <div className={styleClass}>
      {groups.map((group, index) => <PRIVATE_MARKDOWN_LIST_GROUP key={groupKeys[index]} {...group} />)}
    </div>
  );
};
